// ============================================================
// ANSICHTSSACHE-AGENT – Anmeldung des Service Workers
// ============================================================
// Ein Bauteil ohne Anzeige: es haengt `public/sw.js` an den
// Ursprung, mehr nicht. Was der Service Worker dann TUT — und
// vor allem, was er bewusst nicht tut — steht in der Datei
// selbst.
//
// Erst nach `load`, nicht sofort: waehrend die Seite noch laedt,
// konkurriert die Anmeldung mit allem, was der erste Anstrich
// braucht.
//
// Ohne Unterscheidung nach Umgebung. Der Service Worker legt
// nur die Auskunftsseite fuer den Fall ohne Netz ab und faellt
// deshalb auch in der Entwicklung niemandem in den Ruecken —
// und ohne ihn waere die Anwendung genau dort nicht
// installierbar, wo sie zu sehen ist.
// ============================================================

"use client";

import { useEffect } from "react";

export function ServiceWorker() {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    const anmelden = () => {
      navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {
        // Kein Grund, laut zu werden: ohne Service Worker laeuft
        // die Anwendung vollstaendig weiter, sie ist dann nur
        // nicht installierbar.
      });
    };

    if (document.readyState === "complete") {
      anmelden();
      return;
    }

    window.addEventListener("load", anmelden, { once: true });
    return () => window.removeEventListener("load", anmelden);
  }, []);

  return null;
}
